var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "formulate-input-element formulate-input-element--" + _vm.context.type,
      attrs: { "data-type": _vm.context.type }
    },
    [
      _c(
        "GmapMap",
        _vm._b(
          {
            ref: "gmap",
            staticClass: "w-100",
            style: "height:" + _vm.visual.height + "px",
            attrs: {
              center: _vm.markerPosition,
              "map-type-id": _vm.visual.mapTypeId,
              options: _vm.settings.options,
              zoom: _vm.visual.zoom
            }
          },
          "GmapMap",
          _vm.context.attributes,
          false
        ),
        [
          _c("GmapMarker", {
            attrs: {
              clickable: true,
              draggable: true,
              position: _vm.markerPosition
            },
            on: { dragend: _vm.updateMarkerCoordinates }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-end mt-3 position-absolute btn-position-wrapper"
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-sm",
              attrs: { type: "button" },
              on: { click: _vm.getPosition }
            },
            [
              _c("i", { staticClass: "fad fa-map-marker-alt" }),
              _vm._v(" Standort berechnen")
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }